
import TitleBox from '@/components/CSS/TitleBox'
import md5 from 'js-md5'
import { mapGetters } from 'vuex'
export default {
	name: 'setPayPassword',
	components: {
		TitleBox
	},
	computed: {
		...mapGetters({
			userinfo: 'user/userinfo'
			// checkPayPass: "user/checkPayPass",
		})
	},
	props: {
		isComponents: {
			type: Boolean,
			default: false
		}
	},
	data() {
		const validatePass = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请再次输入支付密码'))
			} else if (value !== this.ruleForm.payPass) {
				callback(new Error('两次输入支付密码不一致!'))
			} else {
				callback()
			}
		}
		const validatePayPass = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请输入支付密码'))
			} else if (value.length !== this.$enum.payPassLength) {
				callback(new Error(`请输入${this.$enum.payPassLength}位数支付密码`))
			} else if (!/^[0-9]\d*$/.test(value)) {
				callback(new Error('支付密码只能是数字'))
			} else {
				callback()
			}
		}
		return {
			id: '',
			passwordType: 'password',
			submitLoading: false,
			smsLoading: false,
			show: true,
			timer: null,
			count: 0,
			rules: {
				payPass: [{ required: true, validator: validatePayPass, trigger: 'blur' }],
				payRePass: [{ required: true, validator: validatePass, trigger: 'blur' }],
				code: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
			},
			ruleForm: {
				payPass: '',
				payRePass: '',
				code: ''
			},
			checkPayPass: false
		}
	},
	methods: {
		getCode() {
			const TIME_COUNT = 60
			if (!this.timer) {
				this.count = TIME_COUNT
				this.show = false
				this.timer = setInterval(() => {
					if (this.count > 0 && this.count <= TIME_COUNT) {
						this.count--
					} else {
						this.show = true
						clearInterval(this.timer)
						this.timer = null
						this.smsLoading = false
					}
				}, 1000)
			}
		},
		sendSms() {
			this.smsLoading = true
			let data = {
				action: {
					smsTemplate: 'CHECK'
				}
			}
			this.$store
				.dispatch('user/UserSendSms2', data)
				.then(res => {
					this.smsLoading = false
					if (res.success) {
						this.$message.success('验证码已发送，请注意查收')
						this.getCode()
						this.$refs.code.focus()
						return false
					} else {
						this.$message.warning(res.info)
					}
				})
				.catch(() => {
					this.smsLoading = false
					this.timer = null
				})
		},
		submitForm(formName) {
			this.$refs[formName].validate(valid => {
				if (valid) {
					this.submitLoading = true
					let params = {
						action: {
							smsCode: this.ruleForm.code,
							payPassword: md5(this.ruleForm.payPass)
						}
					}
					// 用户第一次设置支付密码不需要发送短信
					if (!this.checkPayPass) {
						delete params.action.smsCode
					}
					this.$api
						.setUserPayPassword(params)
						.then(res => {
							this.submitLoading = false
							if (!res.success) {
								this.$message.error(res.info)
								return
							}
							if (this.isComponents) {
								this.$emit('setPassHandler')
								return
							}
							this.$message.success(res.info)
							this.$router.go(-1)
						})
						.catch(() => {
							this.submitLoading = false
						})
				}
			})
		},
		back() {
			this.$router.go(-1)
		},
		showPwd() {
			if (this.passwordType === 'password') {
				this.passwordType = ''
			} else {
				this.passwordType = 'password'
			}
			this.$nextTick(() => {
				this.$refs.password.focus()
			})
		}
	},
	created() {
		// console.log("this.checkPayPass", this.checkPayPass);
		this.id = this.$route.query && this.$route.query.id
		this.$store.dispatch('user/UserCheckAccountWhetherSetPayPass').then(res => {
			if (res.success) {
				this.checkPayPass = res.data
			}
		})
	}
}
